import React from 'react';
import styled from '@emotion/styled';
import cx from 'classnames';

const Wrapper = styled('div')`
  display: flex;
  align-items: center;
  &.checked {
    label {
      background: #7e57c2;
    }
    label:after {
      left: 49%;
    }
  }
  &.colored {
    label {
      background: #7e57c2;
    }
  }
  &.disabled {
    label {
      background: #98a6ad;
    }
  }

  input[type='checkbox'] {
    height: 0;
    width: 0;
    visibility: hidden;
    position: absolute;
  }

  label {
    cursor: pointer;
    text-indent: -9999px;
    width: 36px;
    height: 21px;
    background: #98a6ad;
    display: block;
    border-radius: 100px;
    position: relative;
    margin-right: 8px;
    margin-bottom: 0;
  }

  label:after {
    content: '';
    position: absolute;
    top: 3px;
    left: 3px;
    width: 15px;
    height: 15px;
    background: #fff;
    border-radius: 20px;
    transition: 0.3s;
  }

  .left-label {
    margin-right: 8px;
  }
`;

const Toogle = (props) => {
  const { label, leftLabel = null, id, className, checked = false, disabled = false } = props;

  const rightLabel = label;
  const passedProps = Object.assign({}, props);

  return (
    <React.Fragment>
      <Wrapper
        className={cx(
          className,
          checked ? 'checked' : null,
          leftLabel ? 'colored' : null,
          disabled ? 'disabled' : null,
        )}
      >
        {leftLabel ? <span className="left-label">{leftLabel}</span> : null}
        <div>
          <input disabled={disabled} type="checkbox" id={id} name={id} {...passedProps} />
          <label htmlFor={id}></label>
        </div>
        <span>{rightLabel}</span>
      </Wrapper>
    </React.Fragment>
  );
};

export default Toogle;
